import { Role, RoleGetResult } from '@mews-commander/data-access';
import { LocalizedDateTimeFromUtc, LocalizedSmallParagraph, LocalizedSubsectionTitle } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { Divider, Grid, Body, Stack, Container } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';

export const RoleMetadata = ({ role }: { role: RoleGetResult | Role }) => (
    <Container padding={['500', '0']}>
        <Stack distribution="stretch" vertical spacing="200">
            <LocalizedSubsectionTitle textKey={TextKey.Activity} />
            <MetaDataItem labelTextKey={TextKey.CreatedOn} dateTimeString={role.createdUtc} />
            <MetaDataItem labelTextKey={TextKey.UpdatedOn} dateTimeString={role.updatedUtc} />
        </Stack>
    </Container>
);

const MetaDataItem = ({
    dateTimeString,
    labelTextKey,
}: {
    dateTimeString?: string | null;
    labelTextKey: Mews.TextKey;
}) => (
    <>
        <Grid columnGap="50" templateColumns="minmax(20%, min-content) 50%">
            <LocalizedSmallParagraph variant="secondary" textKey={labelTextKey} />
            <Body size="small">
                {dateTimeString ? <LocalizedDateTimeFromUtc utcString={dateTimeString} /> : UnicodeEntity.Dash}
            </Body>
        </Grid>
        <Divider />
    </>
);
